// extracted by mini-css-extract-plugin
export default {"mainWrapper":"mainWrapper__jqOjT","description":"description__YG9Ge","actions":"actions__xscfv","link":"link__t0cDT","warning":"warning__e4SlZ"};